import { render, staticRenderFns } from "./Advising.vue?vue&type=template&id=5aac4f92&scoped=true&"
import script from "./Advising.vue?vue&type=script&lang=js&"
export * from "./Advising.vue?vue&type=script&lang=js&"
import style0 from "./Advising.vue?vue&type=style&index=0&id=5aac4f92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aac4f92",
  null
  
)

export default component.exports